import axios from "axios";
import {CUSTOM_REPORT_API_URL, REPORT_ACTIONS_API_URL} from "../constants/api_routes";
import {getHeader, signOut} from "./user_api";

export const getCustomReportDetails = async (reportId) => {
    try {
        const response = await axios.get(`${CUSTOM_REPORT_API_URL}?custom_report_id=${reportId}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const uploadCustomReport = async (formData) => {
    try {
        const response = await axios.post(`${REPORT_ACTIONS_API_URL}/custom_upload`,formData,{headers:getHeader()});
        return response.data;
    } catch (e) {
        return {
            message:e.response.error,
            status:e.response.status
        }
    }
}



// WEBPACK FOOTER //
// ./src/data/custom_report_upload_api.js